import type {AutomarketplPlatformInput} from '@dms/api/sales';

export function setAutomarketplInspectionAnswer(
  answers: AutomarketplPlatformInput['inspekcja'],
  questionId: number,
  value: number | null,
  note?: string
): AutomarketplPlatformInput['inspekcja'] {
  const remaining = answers?.filter((answer) => answer.pytanieId !== questionId) ?? [];
  if (value !== 0 && value !== 1) {
    return remaining.length ? remaining : undefined;
  }
  const previous = answers?.find((answer) => answer.pytanieId === questionId);
  return [
    ...remaining,
    {
      pytanieId: questionId,
      wartosc: value,
      ...(value === 0 ? {uwagi: note ?? previous?.uwagi ?? ''} : {}),
    },
  ];
}
